import type { CountersResponse } from '@prerender/diagnostics-api';

export type RunCooldown = {
  lastWatermark: Date;
  nextRunAfter: Date;
};

export function cooldownOf(counters: CountersResponse | undefined, now: Date): RunCooldown | undefined {
  if (!counters?.lastRunWatermark || !counters.nextRunAfter) return undefined;

  const nextRunAfter = new Date(counters.nextRunAfter);
  if (now >= nextRunAfter) return undefined;

  return { lastWatermark: new Date(counters.lastRunWatermark), nextRunAfter };
}
